import { useRouter } from 'next/router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useEffect } from 'react'


import { useRef } from 'react';
export interface IRouteChangeProgressProps {
  color?: string
}

export default function RouteChangeProgress(props: IRouteChangeProgressProps) {
  const { color = '#24E783' } = props

  const router = useRouter()
  const progressRef = useRef<NProgress.NProgress>()

  useEffect(() => {
    progressRef.current = NProgress.configure({
      template: `
        <div class="bar" role="bar" style="background:${color};">
              <div class="peg !shadow-none"></div></div><div class="spinner" role="spinner"><div class="spinner-icon !hidden"></div></div>
      `,
    })

    const handleRouteStart = () => NProgress.start()
    const handleRouteDone = () => NProgress.done()

    router.events.on('routeChangeStart', handleRouteStart)
    router.events.on('routeChangeComplete', handleRouteDone)
    router.events.on('routeChangeError', handleRouteDone)

    return () => {
      // Make sure to remove the event handler on unmount!
      router.events.off('routeChangeStart', handleRouteStart)
      router.events.off('routeChangeComplete', handleRouteDone)
      router.events.off('routeChangeError', handleRouteDone)

      progressRef.current?.remove()
    }
  }, [router.events, color])

  return null
}
